<template>
  <div class="container">

    <breadcrumb-group :items="breadcrumbItems" v-if="!isAuWallet()"/>

    <heading-one class="-margin-md">au PAY 残高にチャージ（お借り入れ）</heading-one>

    <wizard-group class="-margin-md">
      <main-wizard :active-index="2" type="mb"></main-wizard>
    </wizard-group>

    <notice-box class="-success -margin-md">
      <notice-header>
        <h3 class="heading">お借り入れのお申し込みが完了いたしました。</h3>
      </notice-header>
      <notice-body>ご利用ありがとうございました。</notice-body>
      <notice-body v-if="!isAuWallet()">お取引の内容は<btn-text routerName="mb004" class="-underline">「お取引履歴のご確認」</btn-text>よりご確認いただけます。</notice-body>
    </notice-box>

    <table-box class="_mb-md-60 _mb-sm-25">
      <table-body>
        <table-row>
          <table-header>
            チャージ予定日
          </table-header>
          <table-data class="-pctextright">
            お手続き完了後、すぐにご利用いただけます。
          </table-data>
        </table-row>
        <table-row>
          <table-header>
            お借り入れ金額
          </table-header>
          <table-data class="-pctextright">
            {{userData.amount * 10000 | numberToCurrency }}
          </table-data>
        </table-row>
      </table-body>
    </table-box>

    <template v-if="!isAuWallet()">
      <btngroup-single class="_mb-md-120 _mb-sm-40">
        <btn-main class="-normal" routerName="mb001">
          会員さま専用サイトトップへ
        </btn-main>
      </btngroup-single>
    </template>
    <template v-else>
      <p class="_mb-md-120 _mb-sm-40">※画面右上の閉じるボタンを押していただき、<br />au PAY アプリに戻ることが出来ます。</p>
    </template>

  </div><!-- container -->
</template>

<script>
import { getUserDataLambdaInvoke } from '../utils/LambdaHelper'
import { isAuWallet } from '../utils/UserAgent'
import HeadingOne from '../components/heading/HeadingOne'
import WizardGroup from '../components/wizard/WizardGroup'
import MainWizard from '../components/wizard/MainWizard'
import NoticeBox from '../components/box/NoticeBox'
import NoticeHeader from '../components/box/NoticeHeader'
import NoticeBody from '../components/box/NoticeBody'
import TableBox from '../components/tables/TableBox'
import TableBody from '../components/tables/TableBody'
import TableRow from '../components/tables/TableRow'
import TableHeader from '../components/tables/TableHeader'
import TableData from '../components/tables/TableData'
import BtnText from '../components/button/BtnText'
import BtngroupSingle from '../components/button/BtngroupSingle'
import BtnMain from '../components/button/BtnMain'

export default {
  name: 'Tem-008',
  metaInfo: {
    title: 'au PAY 残高にチャージ（お借り入れ）｜お借り入れ',
    meta: [
      {name: 'description', content: 'au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。'},
      {name: 'keywords', content: 'au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,会員,会員サイト'}
    ]
  },
  components: {
    BtnText,
    BtnMain,
    BtngroupSingle,
    TableData,
    TableHeader,
    TableRow,
    TableBody,
    TableBox,
    NoticeBody,
    NoticeHeader,
    NoticeBox,
    MainWizard,
    WizardGroup,
    HeadingOne
  },
  data () {
    return {
      breadcrumbItems: [
        {
          text: 'トップ',
          routerName: 'mb001'
        },
        {
          text: 'au PAY 残高にチャージ（お借り入れ）',
          active: true
        }
      ],
      userData: {
        amount: ''
      }
    }
  },
  mounted () {
    try {
      getUserDataLambdaInvoke().then(res => {
        for (let key in res) {
          if (this.userData.hasOwnProperty(key)) {
            this.userData[key] = res[key]
          }
        }
      }).catch(error => {
        this.goToErrorPage(error)
      })
    } catch (e) {
      this.goToErrorPage(e)
    }
  },
  methods: {
    isAuWallet: function () {
      return isAuWallet()
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Tem008.vue